var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconStargreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.755,
    height: 26.395,
    viewBox: "0 0 27.755 26.395",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3436",
    "data-name": "Path 3436",
    d: "M15.894,23.887,7.317,28.4l1.638-9.551L2.007,12.082l9.589-1.39L15.885,2l4.289,8.69,9.589,1.39-6.949,6.764L24.452,28.4Z",
    transform: "translate(-2.007 -2.002)",
    fill: "#6ccd30"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStargreen);
export default __webpack_public_path__ + "static/media/icon_stargreen.d2fc545759a7eb8a57b2bd45cbd23f97.svg";
export { ForwardRef as ReactComponent };